import { gql } from '@apollo/client';

export const GET_QUOTE_STATUS = gql`
  query ZYWAVE_SERVICE_getQuoteStatus($groupId: String = null, $productLineId: String, $browsingCriteria: Map) {
    getQuoteStatus(groupId: $groupId, productLineId: $productLineId, browsingCriteria: $browsingCriteria)
  }
`;
